import { useProfileContext } from "provider/ProfileProvider";
import React from "react";
import { Card } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";

const LockTabData = () => {
  const location = useLocation();
  const { userProfileView } = useProfileContext();
  const referrer = location.pathname + location.search;
  return (
    <>
      <div className="container-lg">
        <div className="row justify-content-center">
          <div className="col-xxl-11 margin_bottomfooter">
            <Card className="position-relative" style={{ minHeight: "350px" }}>
              <Card.Body>
                <div className="withoutlogedin">
                  <h6 className="fs-6 fw-bold">About</h6>
                  <p>I am {userProfileView?.name}</p>
                  <h6>Social Media</h6>
                  <div className="links_sociels d-flex gap-2">
                    <Link to="" className="iconSize sizecontact">
                      <i class="fa-brands fa-facebook-f me-1"></i>
                    </Link>
                  </div>
                </div>
                <div className="logininfo text-center">
                  <h6>
                    Please log in to view the About <br />
                    information.
                  </h6>
                  <div className="viewAllreview">
                    <Link to={`/log-in?authclient=google&referrer=${encodeURIComponent(referrer)}`}>Login</Link>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </div>
        </div>
      </div>
    </>
  );
};

export default LockTabData;
